module.exports = __webpack_public_path__ + "static/img/scene4.abc16cbb.jpg";